/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * UtencilsIcon
 */
export default class UtencilsIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><g fillRule="nonzero"><path d="M11 3a1 1 0 011 1v5.807a1 1 0 01-.47.847c-1.034.648-1.854 1.025-2.53 1.12v9.003a1 1 0 01-1.993.117L7 20.777l.001-9.004c-.676-.094-1.497-.47-2.532-1.119a1 1 0 01-.46-.72L4 9.807V4a1 1 0 011.993-.117L6 4v5.24c.432.248.783.412 1.036.494L7 9.721V4a1 1 0 01.883-.993L8 3a1 1 0 01.993.883L9 4v5.721l.079-.027c.24-.09.55-.241.921-.453V4a1 1 0 011-1zM19.084 13.608a1 1 0 00.942-1.337L16.94 3.663C16.563 2.607 15 2.878 15 4v16.777a1 1 0 102 0v-7.17h2.084z"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

